import React from 'react';
import '../styles/OshiTop3.css';

const OshiCreatorCard = ({ creator, selected, rank, onClick, theme, ownAccent, ownAccentGlow, ownCardTint }) => {
  const tint = ownCardTint || ownAccent;
  return (
    <button
      onClick={onClick}
      className={`oshi3-creator-card ${selected ? 'selected' : ''}`}
      style={{
        background: selected ? `${ownAccent}28` : `${tint}12`,
        borderColor: selected ? ownAccent : `${tint}55`,
        boxShadow: selected
          ? `0 0 20px ${ownAccentGlow}, 0 4px 12px rgba(0,0,0,0.25)`
          : '0 2px 8px rgba(0,0,0,0.15)',
        color: '#ffffff',
        zIndex: rank !== null ? (4 - rank) : 0,
        position: 'relative',
      }}
    >
      {rank !== null && (
        <div
          className="oshi3-creator-card-rank"
          style={{ background: ownAccent }}
        >
          {rank}
        </div>
      )}
      <div className="oshi3-creator-avatar">
        <img src={creator.image} alt={creator.name} />
      </div>
      <span className="oshi3-creator-name">{creator.name}</span>
    </button>
  );
};

export default OshiCreatorCard;
